import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
  FeedOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function LegalHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  
  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header title="LEGAL" subtitle="" />
        <Box>
        </Box>
      </FlexBetween>

      <Box
        mt="20px"
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="160px"
        gap="20px"
        sx={{
          "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
        }}
      >
        {/* ROW 1 */}
        <SceneBox
          value="CGV"
          onClick={() => {
                window.open('https://www.flairflow.com/cgv');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
        <SceneBox
          value="Mention Legales"
          onClick={() => {
                window.open('https://www.flairflow.com/mentions-légales');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
              />
              <SceneBox
          value="Politique de Confidentialité"
          onClick={() => {
                window.open('https://www.flairflow.com/politiquedeconfidentialité');
              }}
          icon={
            <FeedOutlined
              sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
            />
          }
        />
      </Box>
    </Box>
  );
};